import { type ReactNode, useMemo } from 'react';
import { HoverCard } from '@mantine/core';
import { type ITooltipGroupState, TooltipGroupContext } from './tooltipGroupContext';

export interface ITooltipGroupProps {
    children: ReactNode;
    /** Подсказки группы не открываются — например, пока над панелью раскрыто меню или окно её кнопки
     * @default false
     */
    disabled?: boolean;
}

/**
 * Группа подсказок панели инструментов: видна одна подсказка — открылась следующая, прежняя гаснет сразу, без мостика
 * и затухания; следующая не появляется заново, а коротко выезжает с места прежней (как singleton у Tippy, без общей
 * подсказки на группу). Исключительность — `HoverCard.Group` Mantine (floating-ui `FloatingDelayGroup`).
 */
const TooltipGroup = ({ children, disabled = false }: ITooltipGroupProps) => {
    const state = useMemo<ITooltipGroupState>(() => ({ visible: null, last: null }), []);
    const value = useMemo(() => ({ disabled, state }), [disabled, state]);
    return (
        <TooltipGroupContext value={value}>
            <HoverCard.Group>{children}</HoverCard.Group>
        </TooltipGroupContext>
    );
};

export default TooltipGroup;
